"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastGuardMedicalRecord = void 0;
const firestore_1 = require("firebase/firestore");
/**
 * get last MedicalRecord
 *
 * @param firestore
 * @param uid uid del usuario
 * @returns array of MedicalRecordCompat
 */
async function getLastGuardMedicalRecord(firestore, uid) {
    const medicalRecordActiveRef = (0, firestore_1.collection)(firestore, `user/${uid}/medical_records`);
    const medicalRecordActiveQuery = (0, firestore_1.query)(medicalRecordActiveRef, (0, firestore_1.orderBy)("assignation_id", "desc"), (0, firestore_1.limit)(1));
    let medicalRecords;
    try {
        medicalRecords = await (0, firestore_1.getDocs)(medicalRecordActiveQuery);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    // null asertion because TS can't affirm the forEach execute, but I do.
    let myMedicalRecord;
    if (medicalRecords.empty) {
        return null;
    }
    medicalRecords.forEach((medicalRecord) => {
        myMedicalRecord = medicalRecord.data();
    });
    return myMedicalRecord;
}
exports.getLastGuardMedicalRecord = getLastGuardMedicalRecord;
exports.default = getLastGuardMedicalRecord;
